// MyTeams.js
import React, { useCallback, useEffect, useState, useRef } from 'react';
import useFetch from '../../hooks/useFetch';
import { useSelector } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import "../../styles/MyProfile.css";
import Tooltip from '../../components/utils/Tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faToggleOn, faToggleOff  } from '@fortawesome/free-solid-svg-icons';

const MyTeams = () => {
  const authState = useSelector(state => state.authReducer);
  const [fetchData] = useFetch();

  const navigate = useNavigate();
  const userId = authState.user._id;
  const [createdTeams, setCreatedTeams] = useState([]);
  const [hasCretaedTeamStatus, setHasCretaedTeamStatus] = useState(false);
  const [hasCretaedTeamStatusMsg, setHasCretaedTeamStatusMsg] = useState('');
  const [selectedTeamId, setSelectedTeamId] = useState([]);
  const [selectedViewMemberTeamId, setSelectedViewMemberTeamId] = useState(false);
  const [selectedAddMemberTeamId, setSelectedAddMemberTeamId] = useState(false);

  const [hasNewMemberCodeClicked, setHasNewMemberCodeClicked] = useState(false);

  const [myTeamMembers, setMyTeamMembers] = useState([]);

  const [newMemberCodeStatus, setNewMemberCodeStatus] = useState(false);
  const [newMemberCodeStatusMsg, setNewMemberCodeStatusMsg] = useState('');
  const [newMemberCode, setNewMemberCode] = useState('');
  const [newMemberId, setNewMemberId] = useState('');
  const [newMemberName, setNewMemberName] = useState('');
  const [newMemberEmail, setNewMemberEmail] = useState('');
  const [newMemberCodeMsg, setNewMemberCodeMsg] = useState('');
  const [verifyNewMemberCodeButtonClicked, setVerifyNewMemberCodeButtonClicked] = useState(false);
  const [error, setError] = useState('');
  const [addNewButtonClickedStatus, setAddNewButtonClickedStatus] = useState(false);
  const [addNewMemberRecordStatus, setAddNewMemberRecordStatus] = useState(false);
  const [addNewMemberRecordStatusMsg, setAddNewMemberRecordStatusMsg] = useState('');
  
  const [editingTeam, setEditingTeam] = useState(false);
  const [viewingMembersList, setViewingMembersList] = useState(false);
  const [fetchedMembersList, setFetchedMembersList] = useState(false);
  const [membersTeamId, setMembersTeamId] = useState('');

  useEffect(() => {
    fetchMyTeamList(); 
  }, []);

  const fetchMyTeamList = useCallback(() => {
    // console.log("fetchMyTeamList for API call ", userId);
    const config = {
        url: "/myteams/mycreatedlist",
        method: "post",
        headers: { Authorization: authState.token },
        data: { createdBy: userId }
    };
  
    fetchData(config)
        .then(response => {
          // console.log("API Response: ", response); 
            if (response && response.status) {
                // console.log("team list found ", response);
                setHasCretaedTeamStatus(true);
                setCreatedTeams(response.teams);
                setHasCretaedTeamStatusMsg("Teams found. 😊");
            } else {
                // console.log("Teams Code Not found");
                setHasCretaedTeamStatusMsg(`Teams not found! 😔`);
            }
        })
        .catch(error => {
            // console.log("Teams Not found!", error);
            setHasCretaedTeamStatusMsg("Error in getting data");
        });
  }, [fetchData, authState.token]);
  
  
  useEffect(() => {
    if (!authState.isLoggedIn) return;
  }, [authState.isLoggedIn, fetchMyTeamList]);

// here
const newMemberCodeValidationClicked = (newMemberCode) => {
  if (/^TU[a-zA-Z0-9]{12}$/.test(newMemberCode)) {
      fetchNewMemberCode(newMemberCode);
  } else {
      setError('Please enter a valid 14-character Think5Whys User Code starting with TU');
  }
};

const handleNewMemberCodeValidation = () => {
  setVerifyNewMemberCodeButtonClicked(true);
};

const fetchNewMemberCode = useCallback((newMemberCode) => {
  // console.log("newMemberCode for API call ", newMemberCode);
  const config = {
      url: "/auth/verifyt5wcode",
      method: "post",
      headers: { Authorization: authState.token },
      data: { think5whyscode: newMemberCode }
  };

  fetchData(config)
      .then(response => {
          if (response && response.status) {
              // console.log("newMemberCode found ", response);
              setNewMemberCodeStatus(true);
              setNewMemberId(response.t5wcode._id);
              setNewMemberName(response.t5wcode.name);
              setNewMemberCodeStatusMsg(`User Code ${newMemberCode} found. 😊`);
          } else {
              // console.log("User Not found");
              setNewMemberCodeStatus(false);
              setNewMemberCodeStatusMsg(`User Code ${newMemberCode} not found! 😔 Make sure the User Code is valid.`);
          }
      })
      .catch(error => {
          // console.log("newMemberCode Not found!");
          setNewMemberCodeStatus(false);
          setNewMemberCodeStatusMsg(`User Code ${newMemberCode} not found! 😔 Make sure the User Code is valid.`);
      });
}, [authState.token, fetchData, setNewMemberCodeStatus,setNewMemberId,setNewMemberName,setNewMemberName]);


useEffect(() => {
  if (!authState.isLoggedIn) return;
}, [authState.isLoggedIn, fetchNewMemberCode]);
//


const addNewButtonClicked = (teamid, teamCode, teamTitle, teamType, newMemberId, newMemberCode, newMemberName) => {
    setAddNewButtonClickedStatus(true);
    addNewMemberRecord(teamid, teamCode, teamTitle, teamType, newMemberId, newMemberCode, newMemberName);
};

const addNewMemberRecord = useCallback((teamid, teamCode, teamTitle, teamType, newMemberId, newMemberCode, newMemberName) => {
  // console.log("fetchAddNewMemberRecord for API call ", teamid, teamCode, teamTitle, teamType, newMemberId, newMemberCode, newMemberName);
  const newMemberData = {
    teamId: teamid, 
    teamCode: teamCode, 
    teamTitle: teamTitle,
    teamType: teamType,
    creatorCode: authState.user.think5whyscode,
    creatorName: authState.user.name,
    dateCreated: new Date(),
    memberId: newMemberId,
    memberCode: newMemberCode,
    memberName: newMemberName,
    remarks: "New Member "+newMemberName+" Joined in the Team "+teamTitle,
    createdBy: authState.user._id,
    isActive: 1,
    isDeleted: 0
  };

  const config = {
      url: "/myteams/addnewmember",
      method: "post",
      headers: { Authorization: authState.token },
      data: { newMemberData, userId: userId }
  };
  // console.log("fetchAddNewMemberRecord for config call ", config);

  fetchData(config)
      .then(response => {
          if (response && response.status) {
              // console.log("newMemberCode added ", response);
              setAddNewMemberRecordStatus(true);
              setAddNewMemberRecordStatusMsg(`Team Member ${newMemberName} Added. 😊`);
          } else {
              // console.log("User Not added");
              setAddNewMemberRecordStatusMsg(`Team Member ${newMemberName} not added! 😔 Please retry.`);
          }
      })
      .catch(error => {
          // console.log("newMemberCode Not added!");
          setAddNewMemberRecordStatusMsg(`Team Member ${newMemberName} not added! 😔 Please retry.`);
      });
}, [fetchData, setAddNewMemberRecordStatus]);


useEffect(() => {
  if (!authState.isLoggedIn) return;
}, [authState.isLoggedIn, addNewMemberRecord]);

const handleCreateTeamClick = () => {
  navigate("/myprofile-createteam/add");
};

const handleTeamView = (_id) => {
  setSelectedTeamId(prevId => (prevId === _id ? null : _id));
};


  const handleAddMembers = (_id) => {
    setSelectedAddMemberTeamId(prevId => (prevId === _id ? null : _id));
  };

  const handleViewMembers = (_id) => {
    setSelectedViewMemberTeamId(prevId => (prevId === _id ? null : _id));
    setViewingMembersList(!viewingMembersList);
    fetchMyTeamMembersList(_id); 
  };

  const fetchMyTeamMembersList = useCallback((teamId) => { // Accept teamId here
    const config = {
      url: "/myteams/myteammembers",
      method: "post",
      headers: { Authorization: authState.token },
      data: { teamId: teamId, createdBy: userId } // Use passed teamId
    };
    // console.log("fetchData member list data config ", config);
    fetchData(config, { showSuccessToast: false })
      .then(data => {
        // console.log("received data myteammembers: ", data);
        if (data && Array.isArray(data.myTeamMembers)) {
          setMyTeamMembers(data.myTeamMembers);
          setFetchedMembersList(true);
        } else {
          console.error("Invalid response format: members not found in response!");
        }
      })
      .catch(error => {
        console.error('Error fetching team members:', error);
      });
  }, [authState.token, fetchData]);

  const sortedMyTeamMembers = [...myTeamMembers].sort((a, b) => b.memberName - a.memberName);


  const formatDateTime = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const teamTypeNames = {
    PRJ: "Project",
    DEP: "Departmental",
    BRA: "Branch",
    ZON: "Zonal",
    REG: "Regional",
    COM: "Company Wide",
    INS: "Institutional",
    ADM: "Administration",
    MIN: "Ministry",
    PRO: "Professional",
    ACA: "Academic",
    FRI: "Friends",
    FAM: "Family",
    MAN: "Management",
    CAM: "Campaign",
    INV: "Investigation",
    FAC: "Fact Finding",
    FUN: "Fun",
    WOR: "Work"
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);

  // Function to open the modal with the selected team member's details
  const handleToggleStatus = (isActive, name, _id) => {
    setSelectedMember({ isActive, name, _id });
    setIsModalOpen(true); // Show the modal
  };

  // Function to handle confirmation
  const handleConfirm = () => {
    toggleMemberStatus(!selectedMember.isActive, selectedMember._id);
    setIsModalOpen(false); // Close the modal
  };

  // Function to close the modal without action
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  // Function to actually toggle the status
  const toggleMemberStatus = (newStatus, _id) => {
    const config = { 
      url: "/myteammembers/updatestatus",
      method: "post",
      data: { isActive: newStatus, memberId: _id }, 
      headers: { Authorization: authState.token }
    };
    // console.log("updating status config ",config);
    fetchData(config)
      .then(() => {
        navigate("/myprofile-ownteams");
      })
      .catch((error) => {
        console.error("Error updating Member Status:", error);
        setError("Error updating Member Status");
      });
  };


  return (
    <MainLayout>
      <div className='text-lg mt-12 mx-8 border-b border-b-gray-300 text-white'>
        <h2>Profile - My Think5Whys Team / Groups</h2>
      </div>
      <div className='m-auto my-2 p-2 border-2 shadow-md rounded-md md:w-7/12 w-full text-white'>
        <div className="flex justify-between mt-4 items-center border-b border-b-gray-300">
          <h3 className='text-lg mt-1 mx-2 text-white'>Team / Groups I Created</h3>
          <button
            className='bg-purple-700'
            onClick={() => handleCreateTeamClick()}
            style={{ maxWidth: '150px' }}
          >
            Create New
          </button>
        </div>
        <div className="mt-4">
          {createdTeams.length === 0 ? (
            <div className='flex justify-center'>
              <p className='text-orange-600'>You Have Not Created A Team / Group Yet</p>
            </div>
          ) : (
            createdTeams.map((team, index) => (
              <div key={team._id} className='bg-gray-700 my-1 p-4 text-black rounded-md shadow-md'>
                <div className='flex'>
                  <span className='font-medium text-yellow-200'>
                    {index + 1}. {team.teamTitle}
                  </span>
                  <Tooltip text={"View details"} position={"top"}>
                    <span className='ml-auto mr-4 text-blue-500 cursor-pointer' onClick={() => handleTeamView(team._id)}>
                      <i className="fa-solid fa-eye"></i>
                    </span>
                  </Tooltip>
                  <Tooltip text={"Edit this record"} position={"top"}>
                    <Link to={`/myprofile-createteam/${team._id}`} className='mr-2 text-green-600 cursor-pointer'>
                      <i className="fa-solid fa-pen"></i>
                    </Link>
                  </Tooltip>
                  <Tooltip text={"Add Team / Group Members"} position={"top"}>
                    <span className='ml-2 text-blue-500 cursor-pointer' onClick={() => handleAddMembers(team._id)}>
                      <i className="fa-solid fa-user-plus"></i>
                    </span>
                  </Tooltip>
                  <Tooltip text={"View Team / Group Members List"} position={"top"}>
                    <span className='ml-2 text-blue-500 cursor-pointer' onClick={() => handleViewMembers(team._id)}>
                      <i className="fa-solid fa-users"></i>
                    </span>
                  </Tooltip>
                </div>
                {selectedTeamId === team._id && (
                  <div className='bg-gray-600 text-black'>
                    <p><strong>Team/Group Type:</strong> {teamTypeNames[team.teamType]}</p>
                    <p><strong>Created Date:</strong> {formatDateTime(team.dateCreated)}</p>
                    <p><strong>Description:</strong>{team.teamDesc}</p>
                    <p><strong>Do's:</strong>{team.dos}</p>
                    <p><strong>Don't:</strong> {team.dont}</p>
                    <p><strong>Page:</strong> {team.teamMicroPage}</p>
                    <p><strong>My Team Remarks:</strong> {team.myTeamRemarks}</p>
                    <p><strong>Master Team Code:</strong> {team.masterTeamCode}</p>
                    <p><strong>Master Team Title:</strong> {team.masterTeamTitle}</p>
                    <p><strong>Master Team Created By:</strong> {team.masterTeamCreator}</p>
                    <p><strong>Team Has Hierarchy:</strong> {team.isLevel ? "Yes" : "No"}</p>
                  </div>
                )}
                {/* {selectedViewMemberTeamId === team._id && (
                  <div>
                    {team.myTeamMembers.length > 0 ? (
                      team.myTeamMembers.map((teammember, index) => (
                        <div key={index} className='bg-gray-200 text-black border-b border-b-yellow-300 mb-1'>
                          <p><strong>SN:</strong> {index+1}</p>
                          <p><strong>Member Name:</strong><span className="text-blue-500"> {teammember.name}</span></p>
                          <p><strong>Created Date:</strong> {formatDateTime(teammember.dateJoined)}</p>
                          <p><strong>Status:</strong> {teammember.isActive ? "Active" : "Left"}</p>
                        </div>
                      ))
                    ) : (
                      <div className='bg-gray-200 text-black'>
                        <p>No Other Member Found</p>
                      </div>
                    )}
                  </div>
                )} */}
                {selectedAddMemberTeamId === team._id && (
                  <div>
                    <div className='mb-4 flex text-wrap justify-center'>
                      <p className='text-white'>Input a 14 Characters Alphanumeric Think5Whys User Code Starting with TU:</p>
                    </div>
                    <div className="mb-4 flex justify-center">
                      <input
                        type="text"
                        name="newMemberCode"
                        id="newMemberCode"
                        value={newMemberCode}
                        placeholder="Input Referrer ID"
                        onChange={(e) => setNewMemberCode(e.target.value)}
                        className="h-12 text-center p-2 border border-gray-300"
                      />
                    </div>
                    <div className="mb-4 flex justify-center">
                      {error && <p className="text-red-800 justify-left">{error}</p>}
                    </div>
                    <div className='mb-4 flex flex-col items-center'>
                      <p className={newMemberCodeStatus ? "text-green-800 text-lg" : "text-red-600 text-lg"}>
                        {newMemberCodeStatusMsg}
                      </p>
                      <button
                        type="button"
                        className="block w-full md:w-auto bg-green-800 text-white py-2 px-4 rounded-md font-medium hover:bg-primary-dark"
                        onClick={() => {
                          newMemberCodeValidationClicked(newMemberCode);
                          handleNewMemberCodeValidation();
                        }}
                        disabled={newMemberCodeStatus}
                      >
                        {newMemberCodeStatus ? "User ID Validated" : "Validate User ID"}
                      </button>
                    </div>
                    {newMemberCodeStatus && (
                      <div className="mb-2">
                        <div className="mb-4 text-lg text-white">
                          <div>
                            <div className='flex justify-center'>
                              <p className='text-xl text-green-500'>
                                User Code {newMemberCode} Validated for Team: 
                                <span>{team.teamTitle}</span>
                              </p>
                            </div>
                            <div className='flex justify-center'>  
                              <button
                                type="button"
                                className="block w-full md:w-auto bg-green-800 text-white py-2 px-4 rounded-md font-medium hover:bg-primary-dark"
                                onClick={() => {
                                  addNewButtonClicked(team._id, team.teamCode, team.teamTitle, teamTypeNames[team.teamType], newMemberId, newMemberCode, newMemberName );
                                }}
                                disabled={addNewMemberRecordStatus}
                              >
                                Add {newMemberName} To Team {team.teamName}
                              </button>
                            </div>
                          </div>
                          
                          {addNewMemberRecordStatus && (
                            <div className='flex justify-center'>
                              <p className='text-xl text-green-500'>Member {newMemberName} Added To Your Team {team.teamTitle}</p>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                )}
                { selectedViewMemberTeamId === team._id && (
                  <>
                  {myTeamMembers.length > 0 ? (
                    <>
                    {sortedMyTeamMembers.map((teamMember, index) => (
                      <div key={teamMember._id} className="bg-blue-600 my-4 p-4 text-white rounded-lg shadow-lg">
                        <span className={teamMember.isActive ? "text-white" : "text-gray-500"}>
                          {index + 1}. {teamMember.memberName} {' since '}
                          {formatDateTime(teamMember.dateCreated)}{' '}
                          {teamMember.isActive ? "Active" : "Inactive"}
                        </span>
                        <button className="w-10" onClick={() => handleToggleStatus(teamMember.isActive, teamMember.memberName, teamMember._id)}>
                          <i className="fa fa-toggle-on" aria-hidden="true"></i> 
                        </button>
                      </div>
                    ))}
                    {isModalOpen && (
                      <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center">
                        <div className="bg-white p-4 rounded-lg shadow-lg">
                          <h2 className="text-xl text-blue-600 font-semibold">
                            {selectedMember.isActive 
                              ? `Are you sure you want to deactivate ${selectedMember.name}?` 
                              : `Are you sure you want to activate ${selectedMember.name}?`
                            }
                          </h2>
                          <div className="mt-4 flex justify-between">
                            <button 
                              className="bg-red-500 text-white px-4 py-2 rounded" 
                              onClick={handleConfirm}
                            >
                              Yes
                            </button>
                            <button 
                              className="bg-gray-500 text-white px-4 py-2 rounded" 
                              onClick={handleCancel}
                            >
                              No
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                    </>
                  ):(
                    <div>
                      <p>No Members Found in the Team</p>
                    </div>
                  )}
                  </>
                )}
              </div>
            ))
          )}
        </div>
      </div>
    </MainLayout>
  );  
};

export default MyTeams;


